// extracted by mini-css-extract-plugin
module.exports = {"chipWrapper":"D3OzrxI9","divider":"Zv6GuIbF","customDate":"WEDIwpTA","specificDate":"cCalpl4l","menuWrapper":"XZFIqPt5","isCalendarShow":"kd3c6gXa"};